/**
 * Projects Reducer Helper Function
 */

import {
  CreateProjectMutation,
  DeleteProjectMutation,
  JoinProjectMutation,
  UpdateProjectMutation,
} from '../../relay/project';
import { processAddMutation, processDeleteMutation, processMutation } from '../../utils/relay';

export const createProject = ({ input }: ICreateProjectActionPayload, parentID: string) => {
  return processAddMutation<GQL.ICreateProjectInput>(CreateProjectMutation, input, {
    edgeName: 'new_project_edge',
    parentID,
    connectionInfo: [{
      key: 'list_projects',
      rangeBehavior: 'prepend',
    }],
  });
};

export const addTrackToProject =
  ({ licenseParams, projectId, trackId, trackVersion }: IAddTrackToProjectActionPayload) => {
  return processMutation<GQL.IUpdateProjectInput>(UpdateProjectMutation, {
    id: projectId,
    tracks: {
      add: [{
        track_id: trackId,
        version: trackVersion,
      }],
    },
    license_params: licenseParams,
  });
};

export const updateProject = ({ input }: IUpdateProjectActionPayload, updater?: (storeProxy, errors) => void) => {
  return processMutation<GQL.IUpdateProjectInput>(UpdateProjectMutation, input, [], updater);
};

export const joinProject = ({ input }: IJoinProjectActionPayload, updater?: (storeProxy, errors) => void) => {
  return processMutation<GQL.IJoinProjectInput>(JoinProjectMutation, input, [], updater);
};

export const deleteProject = ({ input }: IDeleteProjectActionPayload, parentID: string) => {
  return processDeleteMutation<GQL.IDeleteProjectInput>(DeleteProjectMutation, input, {
    parentID,
    pathToConnection: ['viewer', 'projects'],
    connectionKeys: [{
      key: 'list_projects',
    }],
  });
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/helpers/projects.ts